import { useState } from "react";
import { useTimeLimit } from "./TimeLimitProvider";
import { PinPad } from "./PinPad";
import { useT } from "../i18n/LocaleProvider";

/** Full-screen grey lock shown when the daily time limit is reached. Entering
 *  the grown-up PIN gives back today's time and dismisses the lock. */
export function LockOverlay() {
  const t = useT();
  const { hasPin, verifyPin, resetToday, registerPinAttempt, pinHint } = useTimeLimit();
  const [entering, setEntering] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onComplete = (code: string) => {
    const ok = verifyPin(code);
    registerPinAttempt(ok);
    if (ok) {
      resetToday(); // unlocks: locked becomes false, overlay unmounts
    } else {
      setError(t.lockWrongCode);
    }
  };

  return (
    <div className="lock-overlay" role="dialog" aria-modal="true" aria-label={t.lockTimesUpAria}>
      <div className="lock-card">
        <div className="lock-emoji" aria-hidden="true">
          ⏰
        </div>
        <h2>{t.lockTimesUp}</h2>
        <p>{t.lockTimesUpBody}</p>
        {!hasPin ? (
          // No code set: a grown-up can give back today's time with one tap.
          <button className="pill-btn lock-unlock" onClick={resetToday}>
            {t.lockKeepGoing}
          </button>
        ) : !entering ? (
          <button
            className="pill-btn lock-unlock"
            onClick={() => {
              setEntering(true);
              setError(null);
            }}
          >
            {t.lockGrownUpCode}
          </button>
        ) : (
          <>
            <p className="lock-prompt">{t.lockEnterCode}</p>
            <PinPad onComplete={onComplete} error={error} hint={pinHint} />
          </>
        )}
      </div>
    </div>
  );
}
